import { render } from "./ClientRelease.vue?vue&type=template&id=d219705a&scoped=true"
import script from "./ClientRelease.vue?vue&type=script&lang=js"
export * from "./ClientRelease.vue?vue&type=script&lang=js"

import "./ClientRelease.vue?vue&type=style&index=0&id=d219705a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d219705a"]])

export default __exports__